import React, { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";

import Consignment from "../consignment";
import { getEntity } from "../../modules/crudOperations";

function ConsignmentDetail() {
  const { consignmentId } = useParams();

  const [loading, setLoading] = useState();
  const [consignment, setConsignment] = useState();
  const loadConsignment = useCallback(() => {
    setLoading(true);
    getEntity("consignment", consignmentId, setLoading, setConsignment);
  }, [consignmentId]);

  useEffect(() => {
    loadConsignment();
  }, [loadConsignment]);

  return (
    <Consignment
      detail
      loading={loading}
      consignment={consignment}
      onLoadConsignment={loadConsignment}
    />
  );
}

export default ConsignmentDetail;
